import React from 'react';
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoginService from "../../services/LoginService";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function SSOHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const auth = params.get("auth");
    if (auth) {
      try {
        const payload = JSON.parse(atob(auth));
        LoginService.saveSession(payload);
        navigate("/home");
      } catch (e) {
        navigate("/login");
      }
    } else {
      navigate("/login");
    }
  }, [navigate]);

  // Exibe um loading centralizado enquanto processa o SSO
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      <CircularProgress />
    </Box>
  );
}
